import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import CertificationSection from './components/CertificationSection';
import RegulationsSection from './components/RegulationsSection';
import TransparencySection from './components/TransparencySection';
import ComplianceToolsSection from './components/ComplianceToolsSection';
import UpdatesSection from './components/UpdatesSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const ComplianceCenter = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Compliance Center - ProX11Market | FIFA Regulations & Certifications</title>
        <meta 
          name="description" 
          content="ProX11Market's comprehensive compliance center featuring FIFA regulations, official certifications, transparency documentation, and regulatory excellence in international football transfers." 
        />
        <meta 
          name="keywords" 
          content="FIFA compliance, football transfer regulations, player transfer compliance, FIFA certifications, international transfer rules, work permit regulations, GDPR compliance football" 
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <HeroSection />
          <CertificationSection />
          <RegulationsSection />
          <TransparencySection />
          <ComplianceToolsSection />
          <UpdatesSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ComplianceCenter;